import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { applyColourTokens } from "@/lib/colour";

const DEFAULTS = { hub_name: "FCG AI Marketing Hub", brand_colour: "#0B2545", action_colour: "#E8A33D", has_logo: false, version: 0 };
const CACHE_KEY = "fcg-settings";
const cached = () => {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(CACHE_KEY) || "{}") }; } catch { return DEFAULTS; }
};
const SettingsContext = createContext({ settings: DEFAULTS, reload: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(cached);
  const [logoVersion, setLogoVersion] = useState(0);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/public/settings", { params: { v: Date.now() } });
      setSettings(data);
      setLogoVersion((v) => v + 1);
    } catch {
      /* keep cached values */
    }
  }, []);

  const mergeColours = useCallback((s) => {
    if (s) setSettings((cur) => (cur.version === s.version ? cur : { ...cur, ...s }));
  }, []);

  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    applyColourTokens(settings);
    document.title = settings.hub_name;
    localStorage.setItem(CACHE_KEY, JSON.stringify(settings));
  }, [settings]);

  const logoUrl = settings.has_logo ? `${API}/public/logo?v=${settings.version}-${logoVersion}` : null;

  return <SettingsContext.Provider value={{ settings, reload, logoUrl, mergeColours }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
